import { FC } from 'react';

import { InfiniteScrollTrigger } from '../../../../components/shared/InfiniteScrollTrigger';

interface Props {
    nextPage: number | null;
    loading: boolean;
    onLoadMore: (page: number) => void;
}

export const Pagination: FC<Props> = ({ nextPage, loading, onLoadMore }) => {
    if (!nextPage) return null;

    return (
        <InfiniteScrollTrigger
            loading={loading}
            onLoadMore={() => onLoadMore(nextPage)}
        />
    );
};
